import { getViews, PanelView, SceneView } from '@rendering/lookup';
import { getAuthHeader } from 'src/utils/authHeaderUtil';
import { REQUESTOR } from 'src/utils/Constants';
import { noticeError } from 'src/utils/newRelicUtil';

export const getPreviewUser = () => {
  return {
    tenant: { id: 'vistaprint-prod', type: 'merchants' },
    referer: REQUESTOR,
  };
};

const getViewsByType = async (
  previewType: 'scene' | 'panel',
  productKey: string,
  selectedOptions: Record<string, string>
) => {
  try {
    const views = await getViews({
      authorizationHeader: getAuthHeader().headers.Authorization,
      request: {
        reference: { id: productKey, attributes: selectedOptions },
        tenant: getPreviewUser().tenant,
        previewType: [previewType],
        purpose: 'Product',
        subPurpose: 'Full',
      },
    });

    return views;
  } catch (err) {
    noticeError(err, { method: 'getViewsByType' });
    throw err;
  }
};

export const fetchViews = async (
  productKey: string,
  selectedOptions: Record<string, string>
): Promise<{ sceneViews: SceneView[]; panelViews: PanelView[] }> => {
  try {
    const sceneViewsPromise = getViewsByType('scene', productKey, selectedOptions);
    const panelViewsPromise = getViewsByType('panel', productKey, selectedOptions);

    const [sceneViews, panelViews] = await Promise.all([sceneViewsPromise, panelViewsPromise]);

    return { sceneViews, panelViews } as { sceneViews: SceneView[]; panelViews: PanelView[] };
  } catch (err) {
    noticeError(err, { method: 'fetchViews', productKey, selectedOptions });
    throw err;
  }
};
